// Generated by scripts/build-ui-icons.mjs.
export { TrendUp as default } from "../ui/glyphs-7";
